import { render, staticRenderFns } from "./BatchesDataTable.vue?vue&type=template&id=461ced1c"
import script from "./BatchesDataTable.vue?vue&type=script&lang=js"
export * from "./BatchesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports